module.exports = __webpack_public_path__ + "media/leather_1.00561cfc.mp3";